import React, { useEffect } from "react";
import "./App.css";
import RouteHandler from "./components/route/RouteHandler";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import {
  EMPTY_URL,
  EXCLUDE_LAYOUT_URLS,
  SCHEDULING_URL,
  LOGIN_URL,
  WRONG_URL,
  SCHEDULING_HISTORY_URL,
  ORGANIZATION_URL,
} from "./constants/routeConstants";
import Login from "./pages/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import { LOCALSTORAGE_USER } from "./constants/localStorageConstants";
import Scheduling from "./pages/Scheduling";
import ProtectedRoute from "./components/route/ProtectedRoute";
import { useDispatch } from "react-redux";
import { authActions } from "./store/slices/authSlice";
import SchedulingHistory from "./pages/SchedulingHistory";
import Organization from "./pages/Organization";

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    var loggedInUser = JSON.parse(localStorage.getItem(LOCALSTORAGE_USER));
    if (loggedInUser) {
      dispatch(authActions.setUser(loggedInUser));
    }
  }, [navigate, dispatch]);

  return (
    <>
      <RouteHandler excludeLayout={EXCLUDE_LAYOUT_URLS}>
        <Routes>
          <Route
            path={EMPTY_URL}
            element={<Navigate replace to={SCHEDULING_URL} />}
          />

          <Route
            path={SCHEDULING_URL}
            element={
              <ProtectedRoute linkToNavigate={LOGIN_URL} roles={["Admin"]} />
            }
          >
            <Route path={SCHEDULING_URL} element={<Scheduling />} />
          </Route>

          <Route
            path={SCHEDULING_HISTORY_URL}
            element={
              <ProtectedRoute linkToNavigate={LOGIN_URL} roles={["Admin"]} />
            }
          >
            <Route
              path={SCHEDULING_HISTORY_URL}
              element={<SchedulingHistory />}
            />
          </Route>

          <Route
            path={ORGANIZATION_URL}
            element={
              <ProtectedRoute linkToNavigate={LOGIN_URL} roles={["Admin"]} />
            }
          >
            <Route
              path={ORGANIZATION_URL}
              element={<Organization />}
            />
          </Route>

          <Route
            path={LOGIN_URL}
            element={
              <ProtectedRoute linkToNavigate={SCHEDULING_URL} requiresAuth={false} roles={[]} />
            }
          >
            <Route
              path={LOGIN_URL}
              element={<Login />}
            />
          </Route>

          {/* <Route path={LOGIN_URL} element={<Login />} /> */}
          <Route
            path={WRONG_URL}
            element={<Navigate replace to={SCHEDULING_URL} />}
          />
        </Routes>
      </RouteHandler>
    </>
  );
};

export default App;
